module.exports = __webpack_public_path__ + "static/img/car8.4681c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car8.png
// module id = A0t2
// module chunks = 1